import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import api from './api';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';
import schemas from 'utils/schemas';
import { normalize } from 'normalizr';
import { camelizeKeys } from 'humps';

export function loadFacilityHeader(documentId, siteId) {
  return async (dispatch, getState) => {
    let facilityHeader = getState().facilities.item[documentId];

    let shouldCallApi = !facilityHeader || (!facilityHeader.loaded && !facilityHeader.loading);
    if (!shouldCallApi) return;

    try {
      dispatch({ type: actionTypes.LOAD_FACILITY_HEADER_STARTED, key: documentId });

      const response = await dispatch(sendHttpRequest(api.getFacilityHeader(documentId, siteId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.facility));

      dispatch({
        entitiesCategory: 'facilities',
        type: actionTypes.LOAD_FACILITY_HEADER_SUCCEEDED,
        key: documentId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FACILITY_HEADER_FAILED, key: documentId, error });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadFacilityReports(documentId, siteId) {
  return async (dispatch, getState) => {
    let facilityReports = getState().facilities.item[documentId].facilityReports;
    if (facilityReports && facilityReports.isLoaded) {
      return;
    }

    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.getFacilityReports(documentId, siteId),
          'GetFacilityReportsCommand',
          [eventTypes.FACILITY_REPORTS_EXECUTED],
          false
        )
      );
      if (event.ok) {
        dispatch({
          type: actionTypes.EXECUTE_FACILITY_REPORTS_SUCCEEDED,
          key: documentId,
          event: event
        });
      } else dispatch({ type: actionTypes.EXECUTE_FACILITY_REPORTS_FAILED, key: documentId });
    } catch (error) {
      dispatch({ type: actionTypes.EXECUTE_FACILITY_REPORTS_FAILED, key: documentId, error });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function generateDocumentReport(report) {
  return async dispatch => {
    dispatch({ type: actionTypes.GENERATE_DOCUMENT_REPORT_STARTED, key: report.reportId });

    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.generateDocumentReport(report), null, [eventTypes.DOCUMENT_REPORT_GENERATED])
      );
      if (event.ok) {
        const url = api.buildDownloadUrl(event.eventBody.filePath, event.eventBody.fileName);
        dispatch({ type: actionTypes.GENERATE_DOCUMENT_REPORT_SUCCEEDED, key: report.reportId, url });
        window.location = url;
      } else {
        dispatch({ type: actionTypes.GENERATE_DOCUMENT_REPORT_FAILED, key: report.reportId });
      }
    } catch (error) {
      dispatch({ type: actionTypes.GENERATE_DOCUMENT_REPORT_FAILED, key: report.reportId });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function restartOrRenewFacility(documentId, siteId, offerId, offerSiteId, isRenewal) {
  return async dispatch => {
    const event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        api.restartOrRenewFacility(documentId, siteId, offerId, offerSiteId, isRenewal),
        'RestartOrRenewFacilityCommand',
        [eventTypes.FACILITY_RESTARTED_RENEWED],
        false
      )
    );
    return event;
  };
}
